module.exports = __webpack_public_path__ + "static/media/competencylogoback.31b4614b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/competencylogoback.png
// module id = 1315
// module chunks = 0